import React from "react";

/**
 * Inline replacement for alert(). Renders a dismissible banner.
 *
 * Usage:
 *   const { notice, showError, showSuccess, clear } = useInlineNotice();
 *   <InlineNotice notice={notice} onDismiss={clear} />
 */
export const InlineNotice = ({ notice, onDismiss }) => {
  if (!notice) return null;
  const isError = notice.type !== "success";

  return (
    <div
      className={`border rounded-lg px-4 py-3 flex items-start justify-between gap-3 text-sm ${
        isError
          ? "bg-red-50 dark:bg-red-900/20 border-red-300 dark:border-red-800 text-red-700 dark:text-red-300"
          : "bg-green-50 dark:bg-green-900/20 border-green-300 dark:border-green-800 text-green-700 dark:text-green-300"
      }`}
    >
      <span className="whitespace-pre-line">{notice.message}</span>
      <button
        onClick={onDismiss}
        className="font-bold leading-none opacity-70 hover:opacity-100 shrink-0"
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};
